import React from "react";

import { ReactComponent as DashboardSvg } from "../../assets/navbar/icons/layout-dashboard.svg";
import { ReactComponent as MoonSvg } from "../../assets/navbar/icons/moon.svg";
import { ReactComponent as BellSvg } from "../../assets/navbar/icons/bell.svg";
import { ReactComponent as MicrophoneSvg } from "../../assets/navbar/icons/microphone.svg";
import { ReactComponent as ListNumbersSvg } from "../../assets/navbar/icons/list-numbers.svg";
import { ReactComponent as PlusSvg } from "../../assets/navbar/icons/plus.svg";
import { ReactComponent as DroneSvg } from "../../assets/navbar/icons/drone.svg";
import { ReactComponent as ConstructionSurveySvg } from "../../assets/navbar/icons/construction-survey.svg";
import { ReactComponent as UsersSvg } from "../../assets/navbar/icons/users.svg";
import { ReactComponent as KeySvg } from "../../assets/navbar/icons/key.svg";
import { ReactComponent as LogOutSvg } from "../../assets/navbar/icons/logout.svg";
import { ReactComponent as CollapseLeftSvg } from "../../assets/navbar/icons/layout-sidebar-left-collapse.svg";
import { ReactComponent as ShieldCheckSvg } from "../../assets/navbar/icons/shield-check.svg";
import { ReactComponent as SunSvg } from "../../assets/navbar/icons/sun-high.svg";
import { ReactComponent as AlertTriangleSvg } from "../../assets/navbar/icons/alert-triangle.svg";
import { ReactComponent as XSvg } from "../../assets/navbar/icons/x.svg";
import { ReactComponent as EyeSvg } from "../../assets/navbar/icons/eye.svg";
import { ReactComponent as HighSvg } from "../../assets/alerts/icons/high.svg";
import { ReactComponent as MediumSvg } from "../../assets/alerts/icons/medium.svg";
import { ReactComponent as LowSvg } from "../../assets/alerts/icons/low.svg";
import { ReactComponent as CalenderSvg } from "../../assets/alerts/icons/calender.svg";
import { ReactComponent as OfflineSvg } from "../../assets/devices/icons/offline.svg";
import { ReactComponent as SettingSvg } from "../../assets/devices/icons/setting.svg";
import { ReactComponent as ArrowLeftSvg } from "../../assets/arrow-left.svg";
import { ReactComponent as SensorSvg } from "../../assets/devices/icons/sensor.svg";
import { ReactComponent as CameraSvg } from "../../assets/devices/icons/camera.svg";
import { ReactComponent as InboxSvg } from "../../assets/devices/icons/inbox.svg";
import { ReactComponent as SearchSvg } from "../../assets/search.svg";
import { ReactComponent as FlightSvg } from "../../assets/flight.svg";
import { ReactComponent as FolderSvg } from "../../assets/navbar/icons/folder.svg";
import { ReactComponent as MapSvg } from "../../assets/navbar/icons/map.svg";
import { ReactComponent as LockSvg } from "../../assets/navbar/icons/lock.svg";

export const ShieldIcon = ({ size = 22, color = "currentColor" }) => (
  <ShieldCheckSvg stroke={color} width={size} height={size} />
);

export const TablerDashboard = ({ color = "currentColor", size = 18 }) => (
  <DashboardSvg stroke={color} width={size} height={size} />
);

export const TablerBell = ({ color = "currentColor", size = 18 }) => (
  <BellSvg stroke={color} width={size} height={size} />
);

export const TablerMic = ({ color = "currentColor", size = 18 }) => (
  <MicrophoneSvg stroke={color} width={size} height={size} />
);

export const TablerListNumbers = ({ color = "currentColor", size = 18 }) => (
  <ListNumbersSvg stroke={color} width={size} height={size} />
);

export const TablerPlus = ({ color = "currentColor", size = 18 }) => (
  <PlusSvg stroke={color} width={size} height={size} />
);

export const TablerDrone = ({ color = "currentColor", size = 18, ...props }) => (
  <DroneSvg stroke={color} width={size} height={size} {...props} />
);

export const TablerConstructionSurvey = ({ color = "currentColor", size = 18, ...props }) => (
  <ConstructionSurveySvg stroke={color} width={size} height={size} {...props} />
);

export const TablerUsers = ({ color = "currentColor", size = 18 }) => (
  <UsersSvg stroke={color} width={size} height={size} />
);

export const TablerKey = ({ color = "currentColor", size = 18 }) => (
  <KeySvg stroke={color} width={size} height={size} />
);

export const TablerLogOut = ({ color = "currentColor", size = 18 }) => (
  <LogOutSvg stroke={color} width={size} height={size} />
);

export const TablerCollapseLeft = ({ color = "currentColor", size = 18 }) => (
  <CollapseLeftSvg stroke={color} width={size} height={size} />
);

export const TablerSun = ({ color = "currentColor", size = 18 }) => (
  <SunSvg stroke={color} width={size} height={size} />
);

export const TablerAlertTriangle = ({ color = "currentColor", size = 24 }) => (
  <AlertTriangleSvg stroke={color} width={size} height={size} />
);

export const TablerX = ({ color = "currentColor", size = 18 }) => (
  <XSvg stroke={color} width={size} height={size} />
);

export const TablerSearch = ({ color = "currentColor", size = 18, ...props }) => (
  <SearchSvg stroke={color} width={size} height={size} {...props} />
);

export const TablerEye = ({ color = "currentColor", size = 18 }) => (
  <EyeSvg stroke={color} width={size} height={size} />
);

export const TablerMoon = ({ color = "currentColor", size = 18 }) => (
  <MoonSvg stroke={color} width={size} height={size} />
);

export const TablerHigh = ({ color = "currentColor", size = 18 }) => (
  <HighSvg stroke={color} width={size} height={size} />
);

export const TablerMedium = ({ color = "currentColor", size = 18 }) => (
  <MediumSvg stroke={color} width={size} height={size} />
);

export const TablerLow = ({ color = "currentColor", size = 18 }) => (
  <LowSvg stroke={color} width={size} height={size} />
);

export const TablerCalender = ({ color = "currentColor", size = 18 }) => (
  <CalenderSvg stroke={color} width={size} height={size} />
);

export const TablerOffline = ({ color = "currentColor", size = 18, ...props }) => (
  <OfflineSvg stroke={color} width={size} height={size} {...props} />
);

export const TablerSetting = ({ color = "currentColor", size = 18, ...props }) => (
  <SettingSvg stroke={color} width={size} height={size} {...props} />
);

export const TablerArrowLeft = ({ color = "currentColor", size = 18, ...props }) => (
  <ArrowLeftSvg stroke={color} width={size} height={size} {...props} />
);

export const TablerSensor = ({ color = "currentColor", size = 18, ...props }) => (
  <SensorSvg stroke={color} width={size} height={size} {...props} />
);

export const TablerCamera = ({ color = "currentColor", size = 18, ...props }) => (
  <CameraSvg stroke={color} width={size} height={size} {...props} />
);

export const TablerInbox = ({ color = "currentColor", size = 18, ...props }) => (
  <InboxSvg stroke={color} width={size} height={size} {...props} />
);

export const TablerFlight = ({ color = "currentColor", size = 16, ...props }) => (
  <FlightSvg stroke={color} width={size} height={size} {...props} />
);

export const TablerFolder = ({ color = "currentColor", size = 18, ...props }) => (
  <FolderSvg stroke={color} width={size} height={size} {...props} />
);

export const TablerMap = ({ color = "currentColor", size = 18, ...props }) => (
  <MapSvg stroke={color} width={size} height={size} {...props} />
);

export const TablerLock = ({ color = "currentColor", size = 18, ...props }) => (
  <LockSvg stroke={color} width={size} height={size} {...props} />
);

const iconMap = {
  dashboard: TablerDashboard,
  alerts: TablerBell,
  "voice-alerts": TablerMic,
  "device-list": TablerListNumbers,
  "add-device": TablerPlus,
  "drone-runway": TablerDrone,
  "construction-survey": TablerConstructionSurvey,
  "user-management": TablerUsers,
  "role-management": TablerKey,
  projects: TablerFolder,
  "site-visuals": TablerMap,
};

export function getNavIcon(key) {
  return iconMap[key] || null;
}
